<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">Guardar filtro</span>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" sm="12" md="6">
          <v-text-field
            label="Nombre"
            style="max-width: 50em"
            v-model="filtro.nombre"
            @blur="$v.filtro.nombre.$touch()"
            :error-messages="errorNombre"
            class="anadirAsterisco"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-switch v-model="filtro.publico" label="Publico"></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-switch
            v-model="filtro.fechasDinamicas"
            label="Fechas Dinamicas"
          ></v-switch>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-btn color="red darken-1" text @click="$emit('close')">
        Cancelar
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        :disabled="this.$v.filtro.nombre.$invalid"
        text
        @click="guardarFiltro"
        :loading="loading"
        >Guardar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
const defaultFiltro = {
  nombre: undefined,
  publico: false,
  fechasDinamicas: false,
};
export default {
  data() {
    return {
      filtro: { ...defaultFiltro },
      loading: false,
    };
  },
  validations: {
    filtro: {
      nombre: { required },
    },
  },
  methods: {
    guardarFiltro() {
      this.loading = true;
      this.$store
        .dispatch("listadoAcciones/guardarFiltro", this.filtro)
        .then(() => {
          this.filtro = { ...defaultFiltro };
          this.$v.$reset();
        })
        .finally(() => {
          this.loading = false;
          this.$emit("close");
        });
    },
  },
  computed: {
    errorNombre() {
      if (this.$v.filtro.nombre.$dirty) {
        if (this.$v.filtro.nombre.$invalid) {
          return "Indica un nombre para la plantilla";
        }
      }
    },
  },
};
</script>